<template>
  <div class="mobile-scan-error">
    <!-- v-html, the way ShowResult/Error renders the same key: this sentence carried a <br>
         until the latest copy update, and the translation side can put one back -->
    <h3 class="error-title" v-html="$t('result.scan_unsuccessful')"></h3>
    <h3 class="error-subtitle">{{ $t('result.scan_error_detected') }}</h3>
    <div class="error-items">
      <!-- one tile per reason the backend actually named: a lone tile gets the full-size badge,
           two or more fall into the grid -->
      <div
        v-for="tile in tiles"
        :key="tile.label"
        class="error-item"
        :class="{ single: tiles.length === 1 }"
      >
        <img :src="tile.icon" alt="" />
        <span>{{ $t(tile.label) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import errorHair from '@/assets/MobileScan/error-hair.svg';
import errorTop from '@/assets/MobileScan/error-top.svg';
import errorBottom from '@/assets/MobileScan/error-bottom.svg';
import errorOutfit from '@/assets/MobileScan/error-outfit.svg';

// Keys match the reason values returned by getScanErrorReason in modules/scan-quality-error.
const REASON_TILES = {
  hair: { icon: errorHair, label: 'result.error_cover_neck' },
  top: { icon: errorTop, label: 'result.error_top_loose' },
  bottom: { icon: errorBottom, label: 'result.error_bottoms_loose' },
  outfit: { icon: errorOutfit, label: 'result.error_outfit_loose' },
};

export default {
  name: 'MobileScanError',
  props: {
    // the reasons returned by getScanErrorReason
    reasons: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    tiles() {
      return this.reasons.map(reason => REASON_TILES[reason]).filter(Boolean);
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile-scan-error {
  @apply w-full flex flex-col;
  color: #2c2c2c;
}
.error-title {
  @apply text-center mx-auto text-sm font-semibold leading-normal;
  max-width: 80%;
  color: #262626;
}
.error-subtitle {
  @apply text-center mx-auto mt-3 text-xs font-medium leading-normal;
  color: #595959;
}
.error-items {
  // items-start, not items-center: a two-line label makes its tile taller, and centring would
  // push the shorter tile's icon down out of line with it
  @apply flex flex-row flex-wrap items-start justify-center my-8;
  @screen md {
    @apply flex-no-wrap;
  }
}
.error-item {
  @apply text-xs w-1/2 text-center my-1;
  min-height: 120px;
  @screen md {
    @apply text-sm my-3;
  }
  img {
    // the error-*.svg set are fixed-size circular badges, not free illustrations
    @apply mx-auto;
    width: 96px;
    height: 96px;
  }
  span {
    @apply my-2 w-11/12 inline-block;
  }
  // a single named reason gets the whole width and the full-size badge
  &.single {
    @apply w-full my-4;
    img {
      width: 120px;
      height: 120px;
    }
  }
}
</style>
